import Const from 'constants';

function getModesConfig(params) {
    const {gameType, sport, site = null} = params;

    const modesConfig = Const.MODES_CONFIG[gameType][sport];
    if (site && modesConfig.hasOwnProperty(site)) {
        return {...modesConfig[site]};
    }
    return {...modesConfig};
}

function getModesConfigByActiveMode(params, activeMode) {
    const modesConfig = getModesConfig(params);

    if (activeMode === Const.OVERALL_MODE) {
        return modesConfig;
    }

    const activeModeConfig = {};
    Object.keys(modesConfig).map((mode) => {
        if (mode === activeMode) {
            activeModeConfig[mode] = modesConfig[mode];
        }
    });

    return activeModeConfig;
}

export {getModesConfig, getModesConfigByActiveMode};
